/* eslint-disable*/
import React from "react";
import SystemMaintenanceSpecialFunctions_LoanReductionSetup from "./LoanReductionSetup";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("LoanReductionSetup Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceSpecialFunctions_LoanReductionSetup />
      );
    });
  });
  afterEach(cleanup);
  test("is LoanReductionSetup Loads Successfully", () => {
    expect(screen.getByText("LoanReductionSetup")).toBeInTheDocument;
  });
  test("Custom Test Cases for LoanReductionSetup", () => {
    // START_USER_CODE-USER_LoanReductionSetup_Custom_Test_Case
    // END_USER_CODE-USER_LoanReductionSetup_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceSpecialFunctions_LoanReductionSetup />
      );
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanReductionSetup_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnClose(Button Widget) Test Cases", async () => {
    const btnClose = screen.getByTestId("btnClose");
    expect(btnClose).toBeInTheDocument;
    expect(btnClose.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanReductionSetup_btnClose")
    );
  });
  test("Custom Test Cases for btnClose", () => {
    // START_USER_CODE-USER_btnClose_TEST
    // END_USER_CODE-USER_btnClose_TEST
  });
  test("btnDelete(Button Widget) Test Cases", async () => {
    const btnDelete = screen.getByTestId("btnDelete");
    expect(btnDelete).toBeInTheDocument;
    expect(btnDelete.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanReductionSetup_btnDelete")
    );
  });
  test("Custom Test Cases for btnDelete", () => {
    // START_USER_CODE-USER_btnDelete_TEST
    // END_USER_CODE-USER_btnDelete_TEST
  });
  test("btnEdit(Button Widget) Test Cases", async () => {
    const btnEdit = screen.getByTestId("btnEdit");
    expect(btnEdit).toBeInTheDocument;
    expect(btnEdit.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanReductionSetup_btnEdit")
    );
  });
  test("Custom Test Cases for btnEdit", () => {
    // START_USER_CODE-USER_btnEdit_TEST
    // END_USER_CODE-USER_btnEdit_TEST
  });
  test("grpbxLoanReduction(GroupBox Widget) Test Cases", async () => {
    const grpbxLoanReduction = screen.getByTestId("grpbxLoanReduction");
    expect(grpbxLoanReduction.tagName).toBe("BUTTON");
    expect(grpbxLoanReduction.type).toBe("button");
    expect(grpbxLoanReduction.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxLoanReduction", () => {
    // START_USER_CODE-USER_grpbxLoanReduction_TEST
    // END_USER_CODE-USER_grpbxLoanReduction_TEST
  });
  test("lblLoanReduction(Label Widget) Test Cases", async () => {
    const lblLoanReduction = screen.getByTestId("lblLoanReduction");
    expect(lblLoanReduction.tagName).toBe("LABEL");
    expect(lblLoanReduction.classList).toContain("form-label");
    expect(lblLoanReduction.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:LoanReductionSetup_lblLoanReduction")
    );
  });
  test("Custom Test Cases for lblLoanReduction", () => {
    // START_USER_CODE-USER_lblLoanReduction_TEST
    // END_USER_CODE-USER_lblLoanReduction_TEST
  });
});
